define('modules/form_editor/models/dropdown_item',['require','exports','module','backbone'],function(require, exports, module){
  "use strict";
  var Backbone = require("backbone");
  module.exports = Backbone.Model.extend({
    defaults: {
      text: "",
      value: "",
      valid: true
    }
  });
});

